import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { gql } from '@apollo/client';

import customFieldFragment from 'pages/settings/custom-fields/CustomFieldAddModal/customFieldFragment.gql';
import { useTranslation } from 'i18n';
import useCustomFieldForm from './useCustomFieldForm';
import CustomFieldFormModal from './CustomFieldFormModal';

export const EDIT_CUSTOM_FIELD_MUTATION = gql`
  mutation EditCustomFieldMutation(
    $organizationPk: String!
    $customFieldPk: Int!
    $name: String!
    $choices: [ApplicationCustomFieldChoiceType]
    $fieldType: ApplicationCustomFieldEnum
  ) {
    customFieldEdit(
      organizationPk: $organizationPk
      customFieldPk: $customFieldPk
      name: $name
      choices: $choices
      fieldType: $fieldType
    ) {
      customField {
        ...customFieldFragment
      }
      errors {
        message
        fields
      }
    }
  }
  ${customFieldFragment}
`;

function CustomFieldEditModal({
  customFieldPk,
  initialName,
  choices,
  fieldType,
  isVisible,
  onCancel,
}) {
  const { t } = useTranslation();
  const {
    onSave,
    setFieldErrors,
    fieldErrors,
    clearFieldError,
    generalError,
    isSaving,
  } = useCustomFieldForm({
    mutation: EDIT_CUSTOM_FIELD_MUTATION,
    mutationName: 'customFieldEdit',
    onCancel,
  });

  const onEdit = useCallback(
    (customFieldName, customFieldChoices, customFieldType) =>
      onSave({
        name: customFieldName,
        customFieldPk,
        choices: customFieldChoices,
        fieldType: customFieldType,
      }),
    [onSave, customFieldPk],
  );

  return (
    <CustomFieldFormModal
      onSave={onEdit}
      title={t('CustomFieldEditModal_title')}
      initialName={initialName}
      choices={choices}
      fieldType={fieldType}
      isVisible={isVisible}
      onCancel={onCancel}
      setFieldErrors={setFieldErrors}
      fieldErrors={fieldErrors}
      clearFieldError={clearFieldError}
      generalError={generalError}
      isSaving={isSaving}
    />
  );
}

CustomFieldEditModal.propTypes = {
  isVisible: PropTypes.PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  customFieldPk: PropTypes.string,
  initialName: PropTypes.string,
  choices: PropTypes.array,
  fieldType: PropTypes.string,
};

export default CustomFieldEditModal;
